import { render } from "./FormContactNumber.vue?vue&type=template&id=0bc63c87"
import script from "./FormContactNumber.vue?vue&type=script&lang=js"
export * from "./FormContactNumber.vue?vue&type=script&lang=js"

import "./FormContactNumber.vue?vue&type=style&index=0&id=0bc63c87&lang=css"
script.render = render

export default script